import { useNavigate } from "react-router";
import DashboardCard from '../common/DashboardCard';
import { Button } from '@mui/material';
import EvStationIcon from '@mui/icons-material/EvStation';
import ViewListIcon from '@mui/icons-material/ViewList';
import { Table, Column } from '../../common/Table/Table';

interface ChargingSession {
    addressLine: string;
    registrationNumber: string;
    chargeTimestamp: string;
    income?: number;
    cost?: number;
}

interface ChargingSessionsProps {
    title: string;
    chargingSessions: ChargingSession[];
    incomeCostTitle: 'Income' | 'Cost';
    accentColor?: 'primary' | 'secondary' | 'success' | 'info' | 'warning';
}

function ChargingSessions({ title, chargingSessions, incomeCostTitle, accentColor }: ChargingSessionsProps) {
    const navigate = useNavigate();

    const columns: Column<ChargingSession>[] = [
        {
            id: 'addressLine',
            label: 'Location',
            minWidth: 200,
        },
        {
            id: 'registrationNumber',
            label: 'Registration',
            minWidth: 120,
        },
        {
            id: 'chargeTimestamp',
            label: 'Time',
            minWidth: 150,
        },
        {
            id: incomeCostTitle.toLowerCase(),
            label: incomeCostTitle,
            minWidth: 100,
            align: 'right',
            format: (value: number) => value ? `£${value.toFixed(2)}` : '-',
        },
    ];

    return (
        <DashboardCard
            title={title}
            icon={<EvStationIcon />}
            accentColor={accentColor}
            actions={
                <Button
                    startIcon={<ViewListIcon />}
                    onClick={() => navigate("/share/business/charging-transactions")}
                >
                    View All Transactions
                </Button>
            }
        >
            <Table<ChargingSession>
                columns={columns}
                data={chargingSessions || []}
                pagination={false}
                sortable={true}
                emptyMessage="No charging sessions found"
            />
        </DashboardCard>
    );
}

export default ChargingSessions;
